import makeStyles from '@material-ui/styles/makeStyles';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';

import { SmLocationStatus } from 'app/app.constants';

const SMLocationStatusIndicator = ({ title, status }) => {
  const classes = useStyles(status);

  return (
    <FiberManualRecord
      titleAccess={title}
      fontSize="medium"
      classes={{
        root: classes.root,
      }}
    />
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    fill: (status) => {
      switch (status) {
        case SmLocationStatus.PING:
          return theme.altus.components.SmLocation.statusIndicator.ping;
        case SmLocationStatus.NO_PING:
          return theme.altus.components.SmLocation.statusIndicator.noPing;
        default:
          return theme.altus.components.SmLocation.statusIndicator.unknown;
      }
    },
  },
}));

export default SMLocationStatusIndicator;
